import { useEffect, useRef } from "react";
import { useConfig } from "../providers/config";
import { useGetCustomerSurveyAnswers } from "../providers/customerSurvey";
import { useAuth } from "../contexts/auth-context";
import { useIonAlert } from "@ionic/react";
import { useGetCustomerSurveyModal } from "../providers/customerSurvey/useGetCustomerSurveyModal";
import { useCustomerAddressesStateData } from "../providers/CustomerAddresses/CustomerAddressesStateContext";
import { useTranslation } from "react-i18next";

const useCustomerSurveyCheck = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [presentCustomerSurveyAlert] = useIonAlert();
  const { setCustomerSurveyModal, isCustomerSurveyModalOpen } = useGetCustomerSurveyModal();

  const {
    customerSurvey: { isEnabled, allowDismiss },
  } = useConfig();

  const { isAddressModalOpen } = useCustomerAddressesStateData();

  const isFirstRender = useRef(true);

  const {
    data: customerSurveyAnswers,
    isLoading: isCustomerSurveyAnswersLoading,
    isFetching: isCustomerSurveyAnswersFetching,
    isError: isCustomerSurveyAnswersError,
  } = useGetCustomerSurveyAnswers(user?.phone, {
    enabled: isEnabled && !!user?.phone && !isFirstRender?.current,
  });

  useEffect(() => {
    const shouldShowSurvey =
      isEnabled &&
      user?.phone &&
      !allowDismiss &&
      !isAddressModalOpen &&
      !isFirstRender.current &&
      !isCustomerSurveyModalOpen &&
      !customerSurveyAnswers?.answers &&
      !isCustomerSurveyAnswersLoading &&
      !isCustomerSurveyAnswersFetching &&
      !isCustomerSurveyAnswersError;

    if (shouldShowSurvey) {
      presentCustomerSurveyAlert({
        header: t("Your Input Matters"),
        message: t("Please complete the survey to continue using the app"),
        backdropDismiss: false,
        keyboardClose: false,
        buttons: [
          {
            role: "confirm",
            text: t("Understandable"),
            handler() {
              setCustomerSurveyModal(true);
            },
          },
        ],
      });
    }
    isFirstRender.current = false;
  }, [
    isEnabled,
    user?.phone,
    allowDismiss,
    isAddressModalOpen,
    setCustomerSurveyModal,
    isCustomerSurveyModalOpen,
    presentCustomerSurveyAlert,
    customerSurveyAnswers?.answers,
    isCustomerSurveyAnswersLoading,
    isCustomerSurveyAnswersFetching,
    isCustomerSurveyAnswersError,
  ]);
};

export default useCustomerSurveyCheck;
